import { render, staticRenderFns } from "./plmEcr.vue?vue&type=template&id=2d9c2424&scoped=true"
import script from "./plmEcr.vue?vue&type=script&lang=js"
export * from "./plmEcr.vue?vue&type=script&lang=js"
import style0 from "./plmEcr.vue?vue&type=style&index=0&id=2d9c2424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c2424",
  null
  
)

export default component.exports